// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"yHDFR","input":"lql4a","generateButton":"GgNT5","rightSection":"nSEyT"};